// Create a activity card component
import React from "react";

const { useAxios } = require("#api");

const Switch4 = (props) => {
  const { element, UID, Data } = props;
  const axiosInstance = useAxios();

  /**
   * Returns the value of a specific bit in a hexadecimal number.
   *
   * @param {string} hex - The hexadecimal number as a string.
   * @param {number} bitNum - The position of the bit to retrieve (0-indexed).
   * @returns {number} The value of the bit at the specified position (0 or 1).
   */
  function getBitValue(hex, bitNum) {
    const int = parseInt(hex, 16);
    return (int >> bitNum) & 1;
  }

  function getCurrentDateTimeWithExtra30Seconds() {
    const now = new Date();
    return new Date(now.getTime() + 60000).toISOString().replaceAll('-', '/').replace('T', ' ').replace('Z', '').slice(0, 19);
  }
  
  const setDeviceState = async (BitNum, value) => {
    try {
        const response = await axiosInstance.post(
            "/SetDeviceStat", {
              token: localStorage.getItem('token'),
              UID: UID,
              Stat: `k${BitNum}:${value ? true : false}`,
              Exp: getCurrentDateTimeWithExtra30Seconds(), // current datetime with extra 30 seconds with 2025/12/12 12:12:12 format
            }
          );
        } catch (error) {
          console.log("error", error);
        }
  };

  return (
    <div className="flex flex-col justify-center items-center p-4 bg-white shadow rounded-md max-w-sm ">
      <div className="switchs grid grid-cols-2 w-full gap-4 p-4">
        {element.items.map((item, index) => (
          <div
            className="switch h-24 w-24 bg-gray-500 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-600 text-white rounded-md"
            key={index}
            BitNum={item?.BitNum}
            onClick={() => setDeviceState(item?.BitNum, !getBitValue(Data, item?.BitNum))}
          >
            {item.Name}
            {getBitValue(Data, item?.BitNum) ? (
              <svg
                width="44px"
                height="44px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.29298 3.29289C2.90246 3.68342 2.90246 4.31658 3.29298 4.70711L4.29298 5.70711C4.68351 6.09763 5.31667 6.09763 5.7072 5.70711C6.09772 5.31658 6.09772 4.68342 5.7072 4.29289L4.7072 3.29289C4.31667 2.90237 3.68351 2.90237 3.29298 3.29289ZM19.293 3.29289C19.6835 2.90237 20.3167 2.90237 20.7072 3.29289C21.0977 3.68342 21.0977 4.31658 20.7072 4.70711L19.7072 5.70711C19.3167 6.09763 18.6835 6.09763 18.293 5.70711C17.9025 5.31658 17.9025 4.68342 18.293 4.29289L19.293 3.29289ZM19.7072 14.2929L20.7072 15.2929C21.0977 15.6834 21.0977 16.3166 20.7072 16.7071C20.3167 17.0976 19.6835 17.0976 19.293 16.7071L18.293 15.7071C17.9025 15.3166 17.9025 14.6834 18.293 14.2929C18.6835 13.9024 19.3167 13.9024 19.7072 14.2929ZM3.29298 16.7071C2.90246 16.3166 2.90246 15.6834 3.29298 15.2929L4.29298 14.2929C4.68351 13.9024 5.31667 13.9024 5.7072 14.2929C6.09772 14.6834 6.09772 15.3166 5.7072 15.7071L4.7072 16.7071C4.31667 17.0976 3.68351 17.0976 3.29298 16.7071ZM20.4142 11C20.9665 11.0001 21.4142 10.5524 21.4142 10.0001C21.4143 9.44781 20.9666 9.00007 20.4143 9.00003L20.0001 9C19.4478 8.99996 19.0001 9.44765 19 9.99993C19 10.5522 19.4477 11 20 11L20.4142 11ZM2 10.2072C2.00004 10.7595 2.44779 11.2072 3.00007 11.2071L3.41428 11.2071C3.96657 11.2071 4.41425 10.7593 4.41421 10.207C4.41417 9.65474 3.96643 9.20705 3.41414 9.20709L2.99993 9.20712C2.44765 9.20716 1.99996 9.65491 2 10.2072ZM15.4366 14.9189C16.9865 13.8341 18 12.0354 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 12.0354 7.0135 13.8341 8.56337 14.9189C8.21123 15.3497 8 15.9002 8 16.5C8 17.7099 8.85949 18.7191 10.0012 18.9502C10.0004 18.9667 10 18.9833 10 19C10 19.5523 10.4477 20 11 20H13C13.5523 20 14 19.5523 14 19C14 18.9833 13.9996 18.9667 13.9988 18.9502C15.1405 18.7191 16 17.7099 16 16.5C16 15.9002 15.7888 15.3497 15.4366 14.9189ZM12 14C14.2091 14 16 12.2091 16 10C16 7.79086 14.2091 6 12 6C9.79086 6 8 7.79086 8 10C8 12.2091 9.79086 14 12 14ZM12 16H11.9146H10.5C10.2239 16 10 16.2239 10 16.5C10 16.7761 10.2239 17 10.5 17H11.9146H12.0854H13.5C13.7761 17 14 16.7761 14 16.5C14 16.2239 13.7761 16 13.5 16H12.0854H12Z"
                  fill="#fff"
                />
              </svg>
            ) : (
              <svg
                width="44px"
                height="44px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18 10C18 12.0354 16.9865 13.8341 15.4366 14.9189C15.7888 15.3497 16 15.9002 16 16.5C16 17.7099 15.1405 18.7191 13.9988 18.9502C13.9996 18.9667 14 18.9833 14 19C14 19.5523 13.5523 20 13 20H11C10.4477 20 10 19.5523 10 19C10 18.9833 10.0004 18.9667 10.0012 18.9502C8.85949 18.7191 8 17.7099 8 16.5C8 15.9002 8.21123 15.3497 8.56337 14.9189C7.0135 13.8341 6 12.0354 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10ZM16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10ZM11.9146 16H12H12.0854H13.5C13.7761 16 14 16.2239 14 16.5C14 16.7761 13.7761 17 13.5 17H12.0854H11.9146H10.5C10.2239 17 10 16.7761 10 16.5C10 16.2239 10.2239 16 10.5 16H11.9146Z"
                  fill="#fff"
                />
              </svg>
            )}
          </div>
        ))}
      </div>
      {element.ShowName && <div className="name mt-2">{element.Name}</div>}
    </div>
  );
};

export default Switch4;
